<template>
  <div class="page-header level">
    <div class="level-left">
      <div class='size1-text pri-color'>Past Billing Cycles</div>
    </div>
    <div class="level-right"></div>
  </div>
  <div class="level">
    <div class="level-left">
      <div class="page-heading-label level-item">
          Per Page:
      </div>
      <div class="level-item">
        <select v-on:change="onPageSizeChanged()" id="page-size">
            <option value="10" selected="">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="200">200</option>
        </select>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <button id="export-button" v-on:click="onBtExport()" class="button is-secondary">
          Export to CSV
        </button>
      </div>
    </div>
  </div>
  <ag-grid-vue
      style="width: 100%; height: 600px;"
      class="ag-theme-alpine"
      id="myGrid"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :columnDefs="columnDefs"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :defaultColDef="defaultColDef"
      :modules="modules"
      :rowData="rowData">
  </ag-grid-vue>
  <PageLoading :showLoading="!isReady"></PageLoading>
</template>
<script>
import { AgGridVue } from 'ag-grid-vue3';
import { AllCommunityModules } from 'ag-grid-community';
import PageLoading from '@/components/page-loading.vue';
import GridUtils from '@/shared/grid-utils';

window.dateFormatter = function dateFormatter(params) {
  const dateAsString = params.value;
  const dateParts = dateAsString && dateAsString.length > 0 ? dateAsString.split('-') : '';
  return (dateParts && dateParts.length >= 3)
    ? new Date(dateParts[0], dateParts[1] - 1, dateParts[2]).toLocaleDateString() : '';
};

export default {
  name: 'PastBillings',
  components: { AgGridVue, PageLoading },
  data() {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      modules: AllCommunityModules,
      rowData: null,
      paginationPageSize: null,
      isReady: false,
    };
  },
  mixins: [GridUtils],
  methods: {
    async fetchGridData() {
      await this.$store.dispatch('billCycles/fetchPastBillCycles');
      this.rowData = this.$store.state.billCycles.pastBillCycles;
    },
    async onGridReady(params) {
      this.isReady = false;
      // eslint-disable-next-line no-console
      console.log(params);
      await this.fetchGridData();
      this.isReady = true;
    },
    onBtExport() {
      const expParams = {
        columnKeys: ['FromDate', 'ToDate', 'ProcessDate'],
      };

      this.gridApi.exportDataAsCsv(expParams);
    },
    onPageSizeChanged() {
      const ps = document.getElementById('page-size').value;
      this.gridApi.paginationSetPageSize(Number(ps));
    },
  },
  beforeMount() {
    this.gridOptions = {};
    this.columnDefs = [
      {
        field: 'FromDate',
        headerName: 'From Date',
        editable: true,
        // eslint-disable-next-line no-undef
        valueFormatter: dateFormatter,
      },
      {
        field: 'ToDate',
        headerName: 'To Date',
        editable: true,
        // eslint-disable-next-line no-undef
        valueFormatter: dateFormatter,
      },
      {
        field: 'ProcessDate',
        headerName: 'Process Date',
        minWidth: 140,
        editable: true,
        // eslint-disable-next-line no-undef
        valueFormatter: dateFormatter,
      },
      {
        field: 'Id',
        headerName: '',
        sortable: false,
        filter: false,
        minWidth: 50,
        cellRenderer: (params) => {
          const route = {
            name: 'past-billing-detail',
            params: { id: params.value },
          };
          const link = document.createElement('a');
          link.href = this.$router.resolve(route).href;
          link.innerText = 'View Cycle';
          link.addEventListener('click', (e) => {
            e.preventDefault();
            this.$router.push(route);
          });
          return link;
        },
      },
    ];
    this.defaultColDef = {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: 'agDateColumnFilter',
      filterParams: GridUtils.dateFilterParams,
      resizable: true,
    };
    this.paginationPageSize = 10;
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  computed: {
  },
  props: {
    msg: String,
  },
};

</script>
<style src='ag-grid-community/dist/styles/ag-theme-alpine.css'></style>
<style src='ag-grid-community/dist/styles/ag-grid.css'></style>

<style lang="scss" scoped>
    #export-button {
        font-weight: bold;
    }

@import "~ag-grid-community/src/styles/ag-grid.scss";
@import "~ag-grid-community/src/styles/ag-theme-alpine/sass/ag-theme-alpine-mixin";
.ag-theme-alpine {
    @include ag-theme-alpine((
        // use theme parameters where possible
        header-foreground-color: #FFF,
        header-background-color: #0F3D80,
        font-family: ('Helvetica', 'Arial', 'sans-serif'),
    ));

    .ag-icon {
      color: #FFF;
    }
    .ag-paging-button > .ag-icon {
        color: #000;
    }
    .ag-header-cell-text {
      font-size: 14px;
    }
}

</style>
